export default __webpack_public_path__ + "static/media/logo.8e014f67.svg";